module.exports = __webpack_public_path__ + "static/img/salon_banner_01_zh_h5.0a9781a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/salon_banner_01_zh_h5.png
// module id = 80v3
// module chunks = 34